export default __webpack_public_path__ + "static/media/germ_scientist_badge_smaller@3x.4d5c89bd.png";